import React, { FC } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import Contacts from './Contacts';
import Contact from './Contact';
import Dashboard from './Dashboard';
import Task from './Task';
import Event from './Event';
import Home from './Home';
import Activities from './Activities';
import Applications from './Applications';
import Application from './Application';
import Agencies from './admin/Agencies';
import Candidates from './agencyAdmin/Candidates';
import Profile from './Profile';
import { useSessionStore } from 'stores/session';
import { UserRole } from 'core/enums/userRole';
import LegalNoticePage from './LegalNotice';
import HelpPage from './Help';
import CGUPage from './CGU';
import CGVPage from './CGV';
import AskSubscription from './AskSubscription';
import PaymentSuccess from './PaymentSuccess';
import GlobalSearch from './GlobalSearch';

const CandidateRoutes: FC = () => (
    <Switch>
        <Route path="/ask-subscription" exact>
            <AskSubscription />
        </Route>
        <Route path="/dashboard" exact>
            <Dashboard />
        </Route>
        <Route path="/success" exact>
            <PaymentSuccess />
        </Route>
        <Route path="/contacts" exact>
            <Contacts />
        </Route>
        <Route path="/applications" exact>
            <Applications />
        </Route>
        <Route path="/activities" exact>
            <Activities />
        </Route>
        <Route path="/contact/:id" exact>
            <Contact />
        </Route>
        <Route path="/application/:id" exact>
            <Application />
        </Route>
        <Route path="/task/:id" exact>
            <Task />
        </Route>
        <Route path="/event/:id" exact>
            <Event />
        </Route>
        <Route path="/profile" exact>
            <Profile />
        </Route>
        <Route path="/legal-notice" exact>
            <LegalNoticePage />
        </Route>
        <Route path="/cgu" exact>
            <CGUPage />
        </Route>
        <Route path="/cgv" exact>
            <CGVPage />
        </Route>
        <Route path="/help" exact>
            <HelpPage />
        </Route>
        <Route path="/search" exact>
            <GlobalSearch />
        </Route>
        <Route path="/" exact>
            <Home />
        </Route>
        <Redirect to="/" />
    </Switch>
);

const AdminRoutes: FC = () => (
    <Switch>
        <Route path="/" exact>
            <Redirect to="/agencies" />
        </Route>
        <Route path="/agencies" exact>
            <Agencies />
        </Route>
        <Route path="/candidates" exact>
            <Candidates />
        </Route>
        <Route path="/profile" exact>
            <Profile />
        </Route>
        <Route path="/legal-notice" exact>
            <LegalNoticePage />
        </Route>
        <Route path="/help" exact>
            <HelpPage />
        </Route>
        <Redirect to="/agencies" />
    </Switch>
);

const AgencyAdminRoutes: FC = () => (
    <Switch>
        <Route path="/" exact>
            <Redirect to="/candidates" />
        </Route>
        <Route path="/candidates" exact>
            <Candidates />
        </Route>
        <Route path="/profile" exact>
            <Profile />
        </Route>
        <Route path="/legal-notice" exact>
            <LegalNoticePage />
        </Route>
        <Route path="/help" exact>
            <HelpPage />
        </Route>
        <Redirect to="/candidates" />
    </Switch>
);

const ConnectedRoutes: FC = () => {
    const user = useSessionStore((s) => s.user);

    switch (user?.role) {
        case UserRole.Candidate:
            return <CandidateRoutes />;
        case UserRole.AgencyAdmin:
            return <AgencyAdminRoutes />;
        case UserRole.Admin:
            return <AdminRoutes />;
        default:
            throw Error('Wrong user role type enum in router');
    }
};

export default ConnectedRoutes;
